import script from "./ExamRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamRegistration.vue?vue&type=script&setup=true&lang=js"

import "./ExamRegistration.vue?vue&type=style&index=0&id=47225809&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47225809"]])

export default __exports__